// extracted by mini-css-extract-plugin
export default {"appBarHeight":"48px","containerPaddingX":"12px","paginationRowHeight":"40px"};